/**
 * Per-factory advancement values accepted by
 * `PATCH /projects/:id/update_factory_project/:factoryId`.
 *
 * Backend contract (Postman collection). Product spec Q4 defines a richer
 * lifecycle enum — track alignment in `libs/project/SPEC.md`.
 */
export type ProjectAdvancementStatus =
  'idle' | 'in_progress' | 'validated' | 'rejected';

/** All {@link ProjectAdvancementStatus} values in display order. */
export const PROJECT_ADVANCEMENT_STATUSES: readonly ProjectAdvancementStatus[] =
  ['idle', 'in_progress', 'validated', 'rejected'];
